import { useEffect, useState } from "react";
import Link from "next/link";
import { Col } from "react-bootstrap";
import { signIn } from "next-auth/react";
import Image from "next/image";
import styles from "@/styles/SocialSignInCard.module.css";
import { toast } from "react-toastify";
import { useSession } from "next-auth/react";
import { customerServices } from "@/services/customerServices";
import { useRouter } from "next/router";

function SocialSignInCard(props) {
  const { data } = useSession();
  const session = data?.user;
  const { pageStateHandler, userType } = props;
  const [callbackUrl, setCallBackUrl] = useState("");
  const appointment =
    JSON.parse(sessionStorage.getItem("appointmentBooking")) ?? {};
  const courseBooking =
    JSON.parse(sessionStorage.getItem("courseBooking")) ?? {};
  const router = useRouter();

  useEffect(() => {
    if (userType == "customer") {
      if (
        (typeof window !== "undefined" &&
          appointment &&
          Object.keys(appointment).length) ||
        (typeof window !== "undefined" &&
          courseBooking &&
          Object.keys(courseBooking).length)
      ) {
        if (appointment && Object.keys(appointment).length) {
          if (
            appointment?.selectedAppointment &&
            appointment?.selectedAppointment?.is_free == 1
          ) {
            setCallBackUrl(
              "/free-thank-you?type=appointment&id=" +
                appointment.bookedSlotId +
                "&healer_tz=" +
                appointment.healer_tz
            );
          } else {
            setCallBackUrl(
              "/payment?type=appointment&id=" + appointment.bookedSlotId
            );
          }
        }
        if (courseBooking && Object.keys(courseBooking).length) {
          if (
            courseBooking?.detailData &&
            courseBooking?.detailData?.course &&
            courseBooking?.detailData?.course?.is_free == 1
          ) {
            async function checkClassAvailabilityAndRedirect() {
              try {
                const res = await customerServices.customerCheckClassAvailable({
                  class_id: courseBooking?.detailData?.course?.classes[0]?.id,
                  session_id: courseBooking?.detailData?.session_id,
                });

                if (res.status) {
                  sessionStorage.setItem(
                    "courseBooking",
                    JSON.stringify({
                      detailData: courseBooking?.detailData,
                      bookedSlotId: res.data.id,
                    })
                  );
                  const url = `/free-thank-you?type=course&id=${res.data.id}&healer_tz=${courseBooking?.detailData?.course?.healer?.time_zone}`;
                  setCallBackUrl(url);
                } else {
                  router.push(
                    `/courses/${courseBooking?.detailData?.course?.slug}/detail`
                  );
                  toast.warning(res.message, {
                    autoClose: 5000,
                  });
                }
              } catch (error) {
                console.error("Error checking class availability:", error);
                toast.error("Something went wrong. Please try again later.", {
                  autoClose: 5000,
                });
              }
            }
            checkClassAvailabilityAndRedirect();
          } else {
            setCallBackUrl(
              "/payment?type=course&id=" + courseBooking.bookedSlotId
            );
          }
        }
      } else {
        setCallBackUrl("/customer/profile");
      }
    } else {
      setCallBackUrl("/healer/my-account");
    }
  }, []);

  return (
    <Col sm={7} className="align-self-center">
      <div className={styles["login-customer-card"]}>
        <div className={styles["card-header"]}>
          <h4 className={styles["card-heading"]}>
            Log In as a {userType == "customer" ? "Customer" : "Healer"}
          </h4>
          <p>Log In with your email address</p>
        </div>
        <div className={styles["login-body"]}>
          <ul>
            <li>
              <Link
                href="#"
                onClick={() => signIn("facebook", { callbackUrl })}
              >
                <Image
                  height={20}
                  width={20}
                  src="/images/facebook-icon.svg"
                  alt="Facebook signup"
                />{" "}
                Log In With Facebook
              </Link>
            </li>
            <li>
              <Link href="#" onClick={() => signIn("google", { callbackUrl })}>
                <Image
                  height={20}
                  width={20}
                  src="/images/google-icon.svg"
                  alt="Google Signup"
                />{" "}
                Log In With Google
              </Link>
            </li>
            <li>
              <Link
                href={`/auth/${userType}/signin`}
                shallow={true}
                onClick={() => pageStateHandler("credentialSignIn")}
              >
                <Image
                  height={20}
                  width={20}
                  src="/images/mail-icon.svg"
                  alt=""
                />{" "}
                Log In with Email
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles["card-footer"] + " " + "mb-0"}>
          <p style={{ fontWeight: "800" }}>
            {userType == "customer"
              ? "Book a Free call with Verified Healers"
              : "Free to Join • No Listing Fee"}
          </p>
        </div>
        <div className={styles["card-footer"]}>
          <p>
            Don&apos;t have any account?{" "}
            <Link
              href={`/auth/${userType}/social/signup`}
              shallow={true}
              onClick={() => pageStateHandler("signUp")}
            >
              Create Free Zenkify Profile
            </Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default SocialSignInCard;
